const Raphael = require('node_modules/raphael/raphael.min.js');
window.Raphael = Raphael;
require('node_modules/g.raphael/g.raphael-min.js');
require('js-vendor/_raphael.js');
import 'js/entities/_abstract-base.es6'
import 'js/interface/components/_abstract-component.es6';
import 'js/interface/components/_abstract-svg-component.es6';
import 'js/entities/_flavour-flower.es6';
import 'js/interface/components/_flavour-flower.es6';
import 'js/interface/components/_flavour-flower-interactive.es6';
import 'js/interface/_flower.js';
